import moment from 'moment/moment';

export default function TransomData(fetchedData) {
  if (fetchedData.length === 0) return fetchedData;
  let data = [];
  if (
    moment(fetchedData.at(0).startTime).isAfter(
      moment().startOf('day').add(6, 'hours')
    )
  ) {
    fetchedData.unshift({
      startTime: moment().startOf('day').add(6, 'h'),
      endTime: moment(fetchedData.at(0).startTime),
      empty: true,
    });
  }

  if (
    moment(fetchedData.at(-1).endTime).isBefore(
      moment().endOf('day').add(6, 'h')
    )
  ) {
    fetchedData.push({
      startTime: moment(fetchedData.at(-1).endTime),
      endTime: moment().endOf('day').add(6, 'h'),
      empty: true,
    });
  }

  for (const i of fetchedData.keys()) {
    const el = fetchedData[i];
    data.push(el);
    if (!fetchedData[i + 1]) {
      continue;
    }
    const endTime = moment(fetchedData[i + 1].startTime);
    const startTime = moment(el.endTime);
    if (!startTime.isSame(endTime))
      data.push({ endTime, startTime, empty: true });
  }

  return data;
}
